export { default } from './ActiveFilterToken';



// WEBPACK FOOTER //
// ./app/components/shared/Facets/ActiveFilterToken/index.js